import React from 'react';
import { useQuery } from 'hooks/apollo';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';

import globalMessages from 'translations/messages';

import { Form, Button } from 'antd';
import { EyeOutlined, FormOutlined, BarChartOutlined, ShareAltOutlined } from '@ant-design/icons';

import Loading from 'components/Loading';
import Page from 'components/Page';
import Wizard from 'components/StepsWizard';

import reportQuery from './reportQuery.gql';

import EditSettings from './EditSettings';
import EditContent from './EditContent';
import EditDelivery from './EditDelivery';

import messages from '../messages';
import './editReport.less';

const STEPS = {
  SETTINGS: 'settings',
  CONTENT: 'content',
  DELIVERY: 'delivery',
};

const EditReport = ({ intl: { formatMessage: $t }, match, history }) => {
  const id = match.params.reportId;
  const { refetch, loading, data: { report = {} } = {} } = useQuery(reportQuery, {
    variables: { id },
  });
  const [settingsForm] = Form.useForm();
  const [contentForm] = Form.useForm();
  const [deliveryForm] = Form.useForm();

  if (loading) return <Loading />;

  // Get data
  const hasContent = report.content.length > 0;

  const onStepSubmitted = () => {
    refetch();
  };

  const steps = [{
    key: STEPS.SETTINGS,
    title: $t(messages.basicsPanelTitle),
    icon: <FormOutlined />,
    render: () => <EditSettings form={settingsForm} report={report} onDone={onStepSubmitted} />,
  }];

  if (!report.dashboard) {
    steps.push({
      key: STEPS.CONTENT,
      title: $t(messages.contentPanelTitle),
      icon: <BarChartOutlined />,
      render: () => <EditContent form={contentForm} report={report} onDone={onStepSubmitted} />,
    });
  }
  steps.push({
    key: STEPS.DELIVERY,
    title: $t(messages.deliveryPanelTitle),
    icon: <ShareAltOutlined />,
    disabled: !hasContent && !report.dashboard,
    render: () => <EditDelivery form={deliveryForm} report={report} onDone={onStepSubmitted} />,
  });

  const onStepChange = (index) => {
    const activeKey = steps[index].key;
    history.push(`/reports/${id}/edit/${activeKey}`);
  };

  const submitStep = (index) => {
    let form = null;
    if (index === steps.findIndex(s => s.key === STEPS.SETTINGS)) {
      form = settingsForm;
    } else if (index === steps.findIndex(s => s.key === STEPS.CONTENT)) {
      form = contentForm;
    } else if (index === steps.findIndex(s => s.key === STEPS.DELIVERY)) {
      form = deliveryForm;
    }

    form.submit();
  };

  // const actionsMenuItems = [{
  //   key: 'pdf',
  //   label: <a href={`${config.report.baseUrl}pdf/${id}`} target="_blank"><FormattedMessage {...messages.downloadPDF} /></a>,
  // }, {
  //   key: 'xls',
  //   label: <a href={`${config.report.baseUrl}xls/${id}`} target="_blank"><FormattedMessage {...messages.downloadXLS} /></a>,
  // }];

  const headerActions = [(
    <Link key="primary" to={`/reports/${id}`}>
      <Button type="primary" icon={<EyeOutlined />}>{$t(messages.view)}</Button>
    </Link>
  ),
    // (
    //   <Dropdown key="more" placement="bottomRight" trigger={['click']} menu={{ items: actionsMenuItems }}>
    //     <Button icon={<MoreOutlined />} />
    //   </Dropdown>
    // )
  ];

  const breadcrumb = {
    items: [
      { path: '/reports', breadcrumbName: <FormattedMessage {...globalMessages.reports} /> },
      { path: 'here', breadcrumbName: report.title },
    ],
  };

  return (
    <Page>
      <Page.Header
        title={report.title}
        extra={headerActions}
        breadcrumb={breadcrumb}
      />
      <Page.Content className="edit-report">
        <Wizard
          steps={steps}
          onNext={submitStep}
          onChange={onStepChange}
        />
      </Page.Content>
    </Page>
  );
};

export default injectIntl(EditReport);
